export default __webpack_public_path__ + "static/media/info.298c4735.svg";